<div class="container-system-alternative">
    <div class="container-text">
        <h3>Alternativas a {{system.attributes.name}} y sus competidores</h3>
        <p class="secondary-text">¿Te interesa conocer qué usar en vez de {{system.attributes.name}}? ¡Selecciona la
            opción que quieras y
            conoce
            más
            sobre ellas!</p>
    </div>
    <app-empty-component *ngIf="!system.attributes.can_receive || !system.relationships.system_information.data[0].attributes.alternative_system_ids"></app-empty-component>

    <app-payment-methods-slide *ngIf="system.attributes.can_receive && system.relationships.system_information.data[0].attributes.alternative_system_ids" [systems]="alternativeSystem" (selectMethod)="redirectLandingBySystem($event)">
    </app-payment-methods-slide>
</div>
